import { render, staticRenderFns } from "./EmbeddedPage.vue?vue&type=template&id=20ef0dfe&scoped=true&"
import script from "./EmbeddedPage.vue?vue&type=script&lang=js&"
export * from "./EmbeddedPage.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedPage.vue?vue&type=style&index=0&id=20ef0dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef0dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
